import React, { use, useEffect } from 'react';

import { InvoiceForm } from '../../../Components/Form';
import { FormLayout } from '../../../Components';
import { NewInvoiceIcon } from '../../../Assets/Navigation/NavigationIcons';
import { getObjFromLS } from '../../../Helpers';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AddInvoice = ({ handleToast }) => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Invoice.invoice_form.add_invoice');
  }, []);

  const handleRedirection = () => {
    const { search = '' } = location;
    let dataFromLS = getObjFromLS('module');
    if (dataFromLS.moduleName === 'contacts' && search) return '/contacts';
    else return '/invoices';
  };

  return (
    <FormLayout
      title={t('Invoice.invoice_form.title')}
      Icon={NewInvoiceIcon}
      // closeUrl="/invoices"
      closeUrl={handleRedirection()}
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
      // className="create-invoice-main"
    >
      <InvoiceForm
        title={t('Invoice.invoice_form.sectionTitle')}
        type="add"
        handleToast={handleToast}
        className="create-invoice-main"
      />
    </FormLayout>
  );
};

export default AddInvoice;
